<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline" v-if="detect == 'pc'">
                <h2 class="tit">캐시내역</h2>
            </div>

            <v-divider class="d-md-none" />

            <mypage-dashboard-head class="mb-2 mb-md-12" :class="{ 'mt-n7': detect == 'mobile' }" />

            <v-card elevation="0" style="overflow:visible">
                <v-card-text :class="{ 'pa-0': detect == 'pc' }">
                    <div class="mb-4">
                        <cash-list-filter />
                    </div>

                    <cash-list-type class="mb-2 mb-md-12" />

                    <div>
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                            }"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                        >
                            <span slot="item.createdAt" slot-scope="{ item }">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                            <span slot="item.amount" slot-scope="{ item }">{{ parseInt(+item.amount || 0).format() }}원</span>
                            <span slot="item.result" slot-scope="{ item }">{{ parseInt(+item.result || 0).format() }}원</span>
                        </v-data-table>
                    </div>

                    <div class="mt-30px mt-md-40px">
                        <v-pagination
                            v-bind="{
                                value: page,
                                length: pageCount,
                                'total-visible': 11,
                            }"
                            @input="(page) => $router.push({ query: { ...$route.query, page } })"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import api from "@/api";
import detect from "@/plugins/detect";

import MypageDashboardHead from "@/components/client/mypage/dashboard/mypage-dashboard-head.vue";
import CashListFilter from "@/components/client/mypage/cash/cash-list-filter.vue";
import CashListType from "@/components/client/mypage/cash/cash-list-type.vue";
import CommonLoader from "@/components/common/common-loader.vue";

const headers = [
    { text: "일시", value: "createdAt", align: "center", width: 120 },
    { text: "상세내역", value: "remark", align: "center" },
    // { text: "핀번호", value: "pno", align: "center" },
    { text: "금액", value: "amount", align: "center", width: 150 },
    { text: "잔액", value: "result", align: "center", width: 150 },
];

export default {
    components: {
        MypageDashboardHead,
        CashListType,
        CashListFilter,
        CommonLoader,
    },
    data: () => ({
        cashes: [],
        summary: { totalCount: 0 },

        limit: 10,
        detect,
        headers,

        loading: false,
    }),
    computed: {
        template() {
            switch (detect) {
                case "pc": {
                    return () => import(`@/templates/${this.$theme.pages.mypage}`);
                }

                case "mobile": {
                    return () => import(`@/templates/${this.$theme.pages.default}`);
                }
            }
        },

        items() {
            return [...this.cashes];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            switch (query.type) {
                case "inc": {
                    query.type = JSON.stringify({ $in: ["충전"] });
                    break;
                }

                case "dec": {
                    query.type = JSON.stringify({ $nin: ["충전", "리워드"] });
                    break;
                }

                case "rwd": {
                    query.type = JSON.stringify({ $in: ["리워드"] });
                    break;
                }
            }

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, cashes } = await api.v1.me.cashes.gets({
                    headers: { skip, limit },
                    params,
                });

                this.cashes = cashes;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
